import React from "react";
import { BannerCardProps } from "../../types/common.types";

const BannerCard = ({
  dimention,
  title,
  sms,
  bannerUrl,
  imgUrl,
  onChangeImage,
  viewImage,
  onChangeSms,
}: BannerCardProps) => {
  return (
    <div className="bg-[#F3F5F6] h-[550px] flex items-center w-[342px] pt-10 flex-col justify-between rounded-2xl">
      <div className="bg-white shadow-lg w-72 h-[350px] rounded-3xl p-3">
        <div className="flex items-center gap-2">
          <div className="bg-[#5C5C5C] w-3 h-3 rounded-full" />
          <div>{dimention}</div>
        </div>
        <div className="h-full flex flex-col justify-between pb-9">
          <div className="flex justify-center pt-5 h-32">
            <img
              src={bannerUrl}
              alt={title}
              className="h-full w-auto object-contain"
            />
          </div>
          <div>
            <div className="font-semibold text-lg text-center pt-5">
              {title}
            </div>
            <div className="flex justify-center items-center space-x-2 py-2">
              <button
                className="text-[#396CE8] font-bold border-2 border-[#396CE8] px-5 rounded-2xl"
                onClick={() => {
                  onChangeImage && onChangeImage(title, sms);
                }}
              >
                Change Image
              </button>
              <button
                onClick={() => {
                  viewImage && viewImage(bannerUrl);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="size-6 text-[#396CE8]"
                >
                  <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                  <path
                    fillRule="evenodd"
                    d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
            <div className="flex w-full justify-center items-center">
              <button
                className="font-sm text-lg text-center pt-1 flex items-center justify-center gap-2"
                onClick={() => {
                  onChangeSms && onChangeSms(title);
                }}
              >
                <span className="font-bold text-blue-400 text-sm">
                  Change SMS Body
                </span>

                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-4 h-4 text-blue-400"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="pb-5 pt-5">
        <img src={imgUrl} alt={title} />
      </div>
    </div>
  );
};

export default BannerCard;
